import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass, AsyncPipe, DatePipe, DecimalPipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { Application, GetPismoContractsFn, PismoContract } from '@portal-workspace/grow-shared-library';
import { FlexModule } from '@angular/flex-layout';
import { MatTableModule } from '@angular/material/table';
import { loadingFor } from '@ngneat/loadoff';
import { MessageBoxComponent } from '../message-box/message-box.component';
import { PortalHotToastService } from '../portal-hot-toast-component/hot-toast.service';
import { LooseCurrencyPipe } from '../../pipes/loose-currency.pipe';

@Component({
    selector: 'credit-result-pismo-contracts',
    templateUrl: './credit-result-pismo-contracts.component.html',
    styleUrls: ['./credit-result-pismo-contracts.component.scss'],
    standalone: true,
    imports: [
      MatTableModule,
      NgClass,
      ExtendedModule,
      FlexModule,
      AsyncPipe,
      DatePipe,
      DecimalPipe,
      MessageBoxComponent,
      LooseCurrencyPipe,
    ]
})
export class CreditResultPismoContractsComponent implements OnDestroy {
  @Input({required: true}) application!: Application;
  @Input({required: true}) getPismoContractsFn!: GetPismoContractsFn;
  @Output() clickPismoAccountEvent = new EventEmitter<number>();

  subscriptions: Subscription[] = [];
  loader = loadingFor('tableLoading');
  dataSource: PismoContract[] = [];
  columnsToDisplay = [
    'accountName',
    'pismoAccountNumber',
    'totalLimit',
    'currentBalance',
    'currentUtilisationPct',
    'status',
    'amortisation',
    'creationDate',
    'dishonourCountL12m',
  ];
  hasError = false;
  dataLoaded = false;

  constructor(private toastService: PortalHotToastService) {}

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  loadContracts() {
    if (this.dataLoaded) {
      return;
    }
    this.dataLoaded = true;
    this.hasError = false;
    this.dataSource = [];
    this.subscriptions.push(
      this.getPismoContractsFn(this.application.ApplicationId).pipe(
        this.loader.tableLoading.track(),
        this.toastService.spinnerObservable(),
      ).subscribe({
        next: (contracts: PismoContract[]) => {
          this.dataSource = contracts ?? [];
        },
        error: () => {
          this.hasError = true;
          this.dataSource = [];
        }
      })
    );
  }

  getColumnTitle(column: string): string {
    switch (column) {
      case 'accountName': return 'Account Name';
      case 'pismoAccountNumber': return 'Pismo Account Number';
      case 'totalLimit': return 'Total Limit';
      case 'currentBalance': return 'Current Balance';
      case 'currentUtilisationPct': return 'Current Utilisation %';
      case 'status': return 'Status';
      case 'amortisation': return 'Amortisation';
      case 'creationDate': return 'Creation Date';
      case 'dishonourCountL12m': return 'Count of Dishonours L12m';
      default: return column;
    }
  }

  onClickAccount(accountNumber: number | null) {
    if (accountNumber != null) {
      this.clickPismoAccountEvent.emit(accountNumber);
    }
  }
}
